import { createBuilderModule } from '../../../builder';
import { Header } from './Header';

export default createBuilderModule(Header, {
  name: 'Header',
  inputs: [
    {
      name: 'links',
      type: 'list',
      subFields: [
        { name: 'text', type: 'string' },
        { name: 'url', friendlyName: 'URL', type: 'string' },
      ],
    },
    {
      name: 'button',
      type: 'object',
      subFields: [
        { name: 'text', type: 'string' },
        { name: 'url', friendlyName: 'URL', type: 'string' },
      ],
    },
    {
      name: 'loginButtonText',
      type: 'string',
    },
    {
      name: 'signupButtonText',
      type: 'string',
    },
  ],
});
